// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3TjJX","title":"AfterFrontImage_title__fySM8"};